import { z } from 'zod'

export const schema = z.object({
  provinces: z.array(
    z.object({
      id: z.number().int(),
      name: z.string(),
      slug: z.string(),
    }),
  ),
})

export type schemaType = z.infer<typeof schema>

export type returnType = ApiServerResponse<schemaType>
